/** Bookmaker display utilities for JA Lab (22/09/2026).
 *  14 bookmakers confirmed in DB: bet365, betano, betfair, betvictor, dafabet,
 *  marathonbet, pinnacle, sbo, superbet, unibet, williamhill, 10bet, 1xbet, 888sport.
 *  No logo images exist in DB -- show name only. Never invent partner/sponsor language. */

const BOOKMAKER_COLORS: Record<string, string> = {
  'bet365': '#1a7a3a',
  'betano': '#ff6600',
  'betfair': '#ffc72c',
  'betvictor': '#0055a4',
  'dafabet': '#d4213d',
  'marathonbet': '#003580',
  'pinnacle': '#000000',
  'sbo': '#0072c6',
  'superbet': '#ff0000',
  'unibet': '#14805e',
  'williamhill': '#003580',
  '10bet': '#ff6600',
  '1xbet': '#0072c6',
  '888sport': '#003580',
}

export function getBookmakerColor(name: string | null | undefined): string {
  if (!name) return '#666666'
  return BOOKMAKER_COLORS[name.toLowerCase()] ?? '#666666'
}

export function formatBookmakerDisplay(name: string | null | undefined): string {
  if (!name) return 'Sin bookmaker'
  const displayNames: Record<string, string> = {
    'bet365': 'bet365',
    'betano': 'Betano',
    'betfair': 'Betfair',
    'betvictor': 'BetVictor',
    'dafabet': 'Dafabet',
    'marathonbet': 'Marathonbet',
    'pinnacle': 'Pinnacle',
    'sbo': 'SBO',
    'superbet': 'Superbet',
    'unibet': 'Unibet',
    'williamhill': 'William Hill',
    '10bet': '10bet',
    '1xbet': '1xBet',
    '888sport': '888sport',
  }
  return displayNames[name.toLowerCase()] ?? name
}
